module.exports = __webpack_public_path__ + "static/media/showcase_night_mobile@3x.e027e83f.png";